import { z } from 'zod';

export const medicalCodeSchema = z.object({
  code: z.string(),
  description: z.string(),
});

export type MedicalCodeResult = z.infer<typeof medicalCodeSchema>;

export const medicalCodeTypeSchema = z.enum(['icd10cm', 'cpt', 'hcpcs']);
export type MedicalCodeType = z.infer<typeof medicalCodeTypeSchema>;
